import { ControlParams } from "../../Controls/ControlInterfaces";
import { CryptoAction } from "./CryptoAction";
import { XGButton } from "./XGButton";

export class CryptoButton extends XGButton {
    //#region Constructors
    constructor(params: ControlParams) {
        super({ ...params, action: new CryptoAction(params) });
    }

    //#endregion Constructors
}
